import { render, staticRenderFns } from "./MobileFooterNav.vue?vue&type=template&id=04577524&scoped=true"
import script from "./MobileFooterNav.vue?vue&type=script&lang=js"
export * from "./MobileFooterNav.vue?vue&type=script&lang=js"
import style0 from "./MobileFooterNav.vue?vue&type=style&index=0&id=04577524&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04577524",
  null
  
)

export default component.exports